import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';

import type Block from 'webapp/models-custom/block';

interface Args {
	blockM: Block;
}

export default class BlockSettingsShowOtherComponent extends Component<Args> {
	get block(): Block {
		return this.args.blockM;
	}

	get selected(): boolean {
		return !!this.block.showOther;
	}

	@action
	changeSelected(selected: boolean): void {
		const block = this.block;
		block.showOther = selected;
		block.blockSetup.saveBlock();
	}
	<template>
		<div class="row row--toggle">
			<FormCheckboxSwitchComponent
				@name="showOther"
				@selected={{this.selected}}
				@onChange={{this.changeSelected}}
			/>
			<label>Show more items as 'Other'</label>
		</div>
	</template>
}
